"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = require("react-redux");
var redux_query_react_1 = require("redux-query-react");
var HttpQuery_1 = require("./HttpQuery");
var react_1 = require("react");
/**
 * Hook to request and send mutations
 * @param config
 */
exports.useQuery = function (config) {
    var _a;
    if (!config) {
        return null;
    }
    var shouldRequestData = config.loadData === undefined || config.loadData;
    var state = function (state) { return state; };
    var selected = react_redux_1.useSelector(config.selector || state);
    var data = !config.selector && typeof config.entity === 'string'
        ? (_a = selected) === null || _a === void 0 ? void 0 : _a.entities[config.entity] : selected;
    /**
     * Request data when component mounts
     */
    var _b = redux_query_react_1.useRequest(shouldRequestData ? HttpQuery_1.createQueryConfig(config) : null), requestStatus = _b[0], onRequest = _b[1];
    /**
     * Posting data when onSubmit is trigged
     */
    var _c = redux_query_react_1.useMutation(function (data) {
        return HttpQuery_1.createQueryConfig(__assign(__assign({}, config), { body: data }));
    }), mutationStatus = _c[0], onMutate = _c[1];
    react_1.useEffect(function () {
        if (mutationStatus && mutationStatus.isFinished && config.onComplete) {
            config.onComplete(mutationStatus);
        }
    }, [mutationStatus]);
    react_1.useEffect(function () {
        if (requestStatus && requestStatus.isFinished && config.onComplete) {
            config.onComplete(requestStatus);
        }
    }, [requestStatus]);
    return {
        mutationStatus: mutationStatus,
        requestStatus: requestStatus,
        data: data,
        mutate: onMutate,
        request: onRequest,
    };
};
//# sourceMappingURL=useQuery.js.map